// mixins/globalMethods.js
export const globalMethods = {
  methods: {
    Language(currentLanguage) {
      currentLanguage = currentLanguage === "zh" ? "en" : "zh";
      this.$i18n.locale = currentLanguage;
      localStorage.setItem("lang", currentLanguage);
      this.$message.success(
        currentLanguage === "zh" ? "切换为中文..." : "Switch to English..."
      );
      setTimeout(() => {
        window.location.reload();
      }, 200);
    },
  },
};
